import * as React from "react";
import { Heart } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
const namesData = [{
  name: "Back & Neck Pain",
  meaning: "Chronic stiffness, sharp pain, or reduced mobility in the spine.",
  origin: "Chiropractic & Massage"
}, {
  name: "Sciatica",
  meaning: "Radiating pain, numbness, or tingling down the leg and lower back.",
  origin: "Adjustment & Decompression"
}, {
  name: "Headaches & Migraines",
  meaning: "Tension-type headaches, migraines, and cervicogenic discomfort.",
  origin: "Acupuncture & Alignment"
}, {
  name: "Sports Injuries",
  meaning: "Muscle strains, ligament sprains, and joint performance issues.",
  origin: "Dry Needling & Rehab"
}, {
  name: "Pregnancy Pain",
  meaning: "Pelvic girdle pain, lower back strain, and prenatal wellness.",
  origin: "Webster Technique"
}, {
  name: "Disc Issues",
  meaning: "Herniated or bulging discs causing localized or radiating pain.",
  origin: "Gentle Mobilization"
}, {
  name: "Joint Stiffness",
  meaning: "Reduced range of motion in shoulders, hips, knees, or ankles.",
  origin: "Functional Movement"
}, {
  name: "Nerve Impingement",
  meaning: "Pins and needles, burning sensations, or localized weakness.",
  origin: "Neurological Focus"
}, {
  name: "Posture Correction",
  meaning: "Tech-neck, rounded shoulders, and ergonomic spinal alignment.",
  origin: "Structural Assessment"
}, {
  name: "Whiplash Recovery",
  meaning: "Soft tissue trauma resulting from sudden impact or accidents.",
  origin: "Soft Tissue Therapy"
}];
export default function GirlNamesStartingWithA() {
  return <section data-section-id="160883" id="conditions-overview" className="bg-[#F8F8F6] py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-12 text-center">
          <h2 className="text-[#1A1A2E] mb-4 text-3xl font-medium tracking-tight md:text-4xl lg:text-5xl font-serif">
            Conditions We Treat
          </h2>
          <p className="text-[#4A5568] mx-auto max-w-2xl text-lg font-sans">
            Our multi-disciplinary approach addresses the root cause of your pain, helping you return to the activities you love with professional, expert care.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:gap-8">
          {namesData.map((item, i) => <Card key={item.name} data-index={i} className="group border-[#E2E8F0] hover:border-[#3B8FD4]/50 hover:shadow-lg transition-all duration-300 rounded-2xl bg-white">
              <CardHeader className="pb-3">
                <CardTitle className="text-[#1A1A2E] flex items-center justify-between text-2xl font-medium font-serif">
                  {item.name}
                  <Heart className="text-[#4A5568]/30 group-hover:text-[#3B8FD4] transition-colors duration-300 size-5" />
                </CardTitle>
              </CardHeader>
              <CardContent className="flex flex-col gap-2">
                <div className="flex items-start gap-2">
                  <span className="text-[#1A1A2E] font-semibold font-sans">Symptoms:</span>
                  <span className="text-[#4A5568] font-sans">{item.meaning}</span>
                </div>
                <div className="flex items-start gap-2">
                  <span className="text-[#1A1A2E] font-semibold font-sans">Approach:</span>
                  <span className="text-[#4A5568] font-sans">{item.origin}</span>
                </div>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}